module.exports = __webpack_public_path__ + "img/pptx-file.b14c3287.svg";